module.exports = __webpack_public_path__ + "static/media/fm-halloween-logo.9ac35ad9.png";